<div 
[class.loading]="routeChecker$.value === 'login' ? true : false"
[class.keyword]="routeChecker$.value === 'keyword' ? true : false"
[class.loading-result]="routeChecker$.value === 'result' ? true : false"
>
    <div class="load" id="load-3"></div>
</div>